export const BriefSuccess = ({ onClose }) => (
  <div
    className="flex flex-1 flex-col justify-center overflow-y-auto overscroll-contain px-5 py-14 sm:px-9"
    data-lenis-prevent
    data-testid="brief-success"
  >
    <h3 className="font-display text-3xl font-black leading-[0.95] tracking-tight text-[#e5e5e5] sm:text-4xl">
      BRIEF
      <br />
      <span className="text-[#d4ff00]">RECEIVED.</span>
    </h3>
    <p data-testid="brief-success-message" className="mt-5 max-w-sm text-sm leading-relaxed text-[#a3a3a3]">
      Thank you! Your enquiry has been received. We&apos;ll get back to you shortly.
    </p>
    <button
      type="button"
      onClick={onClose}
      data-testid="brief-success-close"
      className="mt-9 w-fit border border-[#262626] px-6 py-3 label text-[#a3a3a3] transition-colors hover:border-[#d4ff00] hover:text-[#d4ff00]"
    >
      BACK TO THE REEL
    </button>
  </div>
);